import axios from "axios";

import { settings } from "../Services/apiSetting";

import { generatePayload } from "../Components/Common/generatePayload";

const { apiUrl, publicData } = settings;

axios.defaults.withCredentials = true;

export default class publicDataServices {
  static async getFeaturedCategory() {
    try {
      const params = {};
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.getFeaturedCategory),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async getCategories() {
    try {
      const params = {};

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.getCategories),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async getSubCategories() {
    try {
      const params = {};

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.getSubCategories),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async getCombinedCategories() {
    try {
      const params = {};

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.getCombinedCategories),
        config
      );

      // const [categoriesResponse, subCategoriesResponse] = await Promise.all([
      //   publicDataServices.getCategories(),
      //   publicDataServices.getSubCategories(),
      // ]);

      // if (
      //   categoriesResponse?.status === 200 &&
      //   subCategoriesResponse?.status === 200
      // ) {
      //   return {
      //     categories: categoriesResponse.data,
      //     subCategories: subCategoriesResponse.data,
      //   };
      // }

      throw new Error("Failed to fetch combined categories");
    } catch (error) {
      throw error;
    }
  }

  //#region Product APIs
  static async getProducts(skip, take, searchValue, selectedKey, sortValue) {
    try {
      const params = {
        skip,
        take,
        searchValue,
        selectedKey,
        sortValue,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.getProducts),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async getProductById(productId) {
    try {
      const params = {
        Id: productId,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.getProductById),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async checkProductAvailability(data) {
    try {
      const params = {
        ...data,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.checkProductAvailability),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async getRandomProducts(productId, categoryId) {
    try {
      const params = {
        productId,
        categoryId,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.getRandomProducts),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async requestQuotation(data) {
    try {
      const params = {
        ...data,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.requestQuotation),
        config
      );
    } catch (err) {
      throw err;
    }
  }
  //#endregion

  static async newsletterSub(email) {
    try {
      const params = {
        emailAddress: email,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.newsletterSub),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async contactUs(data) {
    try {
      const params = {
        ...data,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.contactUs),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async getCatalogs() {
    try {
      const params = {};

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.getCatalogs),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  //#region Promotions
  static async getPromotions() {
    try {
      const params = {};

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.getPromotions),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async getPromotionDetails(promotionId, promotionName) {
    try {
      const params = {
        promotionName,
        promotionId,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, publicData.getPromotionDetails),
        config
      );
    } catch (err) {
      throw err;
    }
  }
  //#endregion
}
